export const formatDate = (iso) => {
  try {
    return new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};

export const formatMedia = (m) => Number(m).toFixed(2).replace(".", ",");

export const downloadBlob = (data, filename) => {
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export const StatCard = ({ label, value, testid }) => (
  <div className="border border-navy/10 bg-white p-6" data-testid={testid}>
    <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-slate-500">{label}</p>
    <p className="mt-2 font-serif text-4xl text-navy">{value}</p>
  </div>
);

export const SEDE_OPTIONS = ["Napoli - Viale Augusto", "Napoli - P.tta Falcone", "Milano - Corso Porta Romana"];
export const AREA_OPTIONS = ["Diritto Civile e Contratti", "Infortunistica e Risarcimento", "Diritto Tributario", "Recupero Crediti", "Altro"];
